import classnames from 'classnames';
import React from 'react';
import { Field, useField } from 'react-final-form';

import { SelectInput } from '../../../../interfaces';
import { useFormInput } from '../../../../libs/hooks';
import { InputLabelComponent } from '../../input-label';
import { InputMessageComponent } from '../../input-message';

export const SelectComponent: React.FC<SelectInput> = (props: SelectInput) => {
  const {
    className,
    defaultOptionLabel = '',
    description,
    disabled,
    label,
    name,
    required = true,
    validators,
    values,
  } = props;
  const memoizedValues = React.useMemo(
    () =>
      values.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      )),
    [values],
  );

  const { id, texts, validate } = useFormInput({
    description,
    disabled,
    label,
    name,
    required,
    validators,
  });
  const defaultOptionValue = required ? undefined : '';

  const metaField = useField(id, { subscription: { error: true, touched: true } });
  const error = metaField.meta.touched && metaField.meta.error;
  return (
    <div
      className={classnames('fr-select-group', className, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'fr-select-group--disabled': disabled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'fr-select-group--error': !!error,
      })}>
      <InputLabelComponent disabled={disabled} id={id} texts={texts} />
      <Field
        aria-describedby={`${id}-messages`}
        className={classnames('fr-select', {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'fr-select--error': !!error,
        })}
        component="select"
        disabled={disabled}
        id={id}
        name={id}
        required={required}
        validate={validate}>
        <option value={defaultOptionValue}>{defaultOptionLabel}</option>
        {memoizedValues}
      </Field>
      <InputMessageComponent error={error} id={id} />
    </div>
  );
};

SelectComponent.displayName = 'SelectComponent';
